import Image from "next/image";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

const features = [
  {
    title: "FREE SHIPPING",
    description: "On orders over $50.",
  },
  {
    title: "30-DAY RETURNS",
    description: "Easy returns within 30 days.",
  },
  {
    title: "SECURE PAYMENT METHOD",
    description: "Safe, encrypted payments.",
  },
  {
    title: "TOP-QUALITY WHEELS",
    description: "Durable, refurbished wheels.",
  },
];

export default function CTABannerSection() {
  return (
    <section>
      {/* Banner with Background Image */}
      <div className="relative h-[810px] ">
        <Image
          src="/image/home/cta-banner.png"
          alt="CTA Banner"
          fill
          className="object-cover"
          priority
        />
        {/* Gradient Overlay */}
        <div
          className="absolute inset-0"
          style={{
            background:
              "linear-gradient(287.56deg, rgba(0, 0, 0, 0) 0.3%, rgba(0, 0, 0, 0.6) 44.23%)",
          }}
        />
        {/* Content */}
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center">
          <h2 className="font-plus-jakarta text-4xl md:text-5xl font-bold text-white leading-tight mb-5 max-w-xl mx-auto">
            READY TO FIND YOUR PERFECT WHEEL?
          </h2>
          <p className="font-plus-jakarta text-white/80 mb-8">
            Start shopping or selling today! It&apos;s fast, easy, and secure.
          </p>
          <div className="flex items-center gap-3">
            <span className="font-plus-jakarta font-semibold text-white">
              Contact Us
            </span>
            <Button className="cursor-pointer w-20 h-10 rounded-full bg-primary-500 p-0">
              <ArrowRight className="w-6 h-6" />
            </Button>
          </div>
        </div>

        {/* Features Bar - Inside banner at bottom */}
        <div className="absolute bottom-12 left-0 right-0 py-12 px-4 md:px-8 lg:px-20">
          <div className="flex flex-col md:flex-row justify-between items-center gap-8">
            {features.map((feature, index) => (
              <div
                key={index}
                className={`text-center flex-1 ${
                  index < features.length - 1
                    ? "md:border-r md:border-white/30"
                    : ""
                }`}
              >
                <h3 className="font-plus-jakarta font-bold text-md text-white mb-1">
                  {feature.title}
                </h3>
                <p className="font-plus-jakarta text-neutral-50/50 text-sm">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
